import React, { useContext, createContext, useState, Dispatch, SetStateAction, FC } from 'react';

export interface IConferenceContext {
  registeredConferenceId?: string;
  setRegisteredConferenceId?: Dispatch<SetStateAction<string | undefined>>;
}

const ConferenceContext = createContext<IConferenceContext>({});
const ConferenceWrapper: FC = ({ children }) => {
  const [registeredConferenceId, setRegisteredConferenceId] = useState<string>();
  return (
    <ConferenceContext.Provider
      value={{
        registeredConferenceId,
        setRegisteredConferenceId,
      }}
    >
      {children}
    </ConferenceContext.Provider>
  );
};
const useConferenceContext = () => useContext(ConferenceContext);

export { ConferenceWrapper, useConferenceContext };
